export default "/Frontend/dist/event-background3-grey.b360037d733b5f8783953367874b766a.svg";